/**
 * Imperative handle onto the live map instance.
 *
 * The dev panel drives the camera and schedule reload directly rather than through props:
 * TransitMap's MapLibre instance and deck.gl overlay are created once in an effect and never
 * re-created, so there is no render pass to thread a "fly here" through. TransitMap fills
 * these in when the map is ready and resets them to no-ops on teardown, so calling one early
 * is harmless.
 *
 * Its own module so the dev panel can import the handle without importing the map component:
 * pulling in the whole deck.gl module graph to read four function references would be a lot
 * of bundle for a DEV-only panel.
 */
import type { ScheduleMode } from '../../store/dev'

export const mapControls: {
  resetView: () => void
  flyTo: (lat: number, lon: number) => void
  reloadWithSchedule: (schedule: ScheduleMode) => void
  clearScheduleCache: () => void
} = {
  resetView: () => {},
  flyTo: () => {},
  reloadWithSchedule: () => {},
  clearScheduleCache: () => {},
}
